module.exports = __webpack_public_path__ + "img/1C70C6_09294C_0F3F73_52B3F6-256px.a8763372.png";